'use es6'; // Added this as a one off to fix the post filter widget. This wiring was
// previously included in public_common via common_init.js

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

var PostFilterWidget = /*#__PURE__*/function () {
  function PostFilterWidget() {
    _classCallCheck(this, PostFilterWidget);

    this.getShowAllFiltersLinkEventHandler = function (link) {
      return function (event) {
        var children = link.previousElementSibling.children;

        if (children) {
          [].slice.call(children, 0).forEach(function (child) {
            child.style.display = 'block';
          });
        }

        link.style.display = 'none';
        event.preventDefault();
        event.stopPropagation();
      };
    };
  }

  _createClass(PostFilterWidget, [{
    key: "setup",
    value: function setup() {
      var _this = this;

      var filterLinksNodes = [].slice.call(document.querySelectorAll('.filter-expand-link'), 0);
      filterLinksNodes.forEach(function (link) {
        link.addEventListener('click', _this.getShowAllFiltersLinkEventHandler(link));
      });
    }
  }]);

  return PostFilterWidget;
}();

export { PostFilterWidget as default };